const styles = {
  root: {},
  stepContainer: {
    minHeight: { xs: '100dvh', sm: 400 },
  },
}
export default styles
